import { BaseInstruction } from './base.instruction';
export class DynamicFieldInstruction extends BaseInstruction {}